import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import { Copy } from '@/components/elements';
import { gridCalc, tabletPortrait } from '@/components/utils';

import { Intro } from '../Intro';
import { Wrapper } from '../Wrapper';

export const StyledIntro = styled(Intro)`
  padding-top: 0;
`;

export const StyledWrapper = styled(Wrapper)`
  padding-top: 0;
`;

export const StyledTestimonials = styled.section`
  margin-bottom: var(--distance-dynamic-xl);
  padding-top: var(--distance-dynamic-l);
  background-color: var(--color-surface-light-subdued);
`;

export const StyledTestimonialsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: var(--distance-static-5xl);
`;

export const StyledNavigationButton = styled.div`
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  gap: var(--distance-static-l);
`;

export const StyledSlider = styled.div`
  position: relative;
  width: auto;
  margin: 0 auto;

  @media screen and (${tabletPortrait}) {
    width: ${gridCalc(8)};
  }
`;

export const StyledSwiper = styled(Swiper)`
  margin-bottom: var(--distance-static-xxl);

  & > ul {
    box-sizing: border-box;
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export const StyledOutOfCopy = styled(Copy)`
  color: var(--color-testimonials-main);
`;
